import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { AiImageService } from '../ai-art/aiimage.service';
import { DamserviceService } from "../dam/damservice.service";
import { AuthService } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";

@Component({
  selector: 'app-ai-art',
  templateUrl: './ai-art.component.html',
  styleUrls: ['./ai-art.component.css']
})
export class AiArtComponent implements OnInit {

  title = 'AI Art by Crafttor Workspace';

  constructor(
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private aiService: AiImageService,
    private damService: DamserviceService,
    private authService: AuthService,
    private organisationService: OrganisationService,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  isMobile: any;
  currentUser: User;
  mobileView: boolean = false;

  workspaces = [];
  boards = [];
  notifications = [];
  showLoader: boolean = false;
  ownerEmail: String;
  planName: String;
  ownerName: String;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  totalAllowedInvites: any;
  planId: any;
  workspaceCountAllowed: any;
  userPic: any;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  edittedWorkspaceEmail: string = '';
  edittedWorkspaceName: string = '';

  mobileViewSection: boolean = false;
  workspaceListStyle = "none";
  boardsListStyle = "none";

  prompt: string = '';
  images: File[] = [];
  base64Images: string[] = [];
  generatedImage: string = '';

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor digital assets management is a trendy and awesome file manager. You can store, organise and tag your assets in an attractive manner. Hurry up, sign up today!'},
      { name: 'keywords', content: 'digital assets management, dam, DAM, free assets upload, digital storage, cloud storage, assets storage, assets tagging, organise digital assets, images upload' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.mobileView = false;
    }

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();
    }else{
      this.router.navigate(['/login']);
    }
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.edittedWorkspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.edittedWorkspaceEmail = data.email;
      this.ownerListApi();
    },
    (error) => {
      if(error.status == 500){
        // this.router.navigate(['/maintenance']);
      } else {

      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.totalAllowedInvites = data.allowed_seats;
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
    });
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }

  async onImageChange(event: any) {
    this.images = Array.from(event.target.files);
    this.base64Images = [];

    for (const file of this.images) {
      const base64 = await this.aiService.convertImageToBase64(file);
      this.base64Images.push(base64);
    }
  }

  generateTextToImage() {
    this.aiService.generateFromText(this.prompt).subscribe((res: any) => {
      this.generatedImage = res.output[0];
    });
  }

  generateImageToImage() {
    if (this.base64Images.length) {
      this.aiService.generateFromImage(this.base64Images[0], this.prompt).subscribe((res: any) => {
        this.generatedImage = res.output[0];
      });
    }
  }

  goToWorkspace() {
    this.router.navigate(['/dam']);
  }

  openWorkspaceListDialog() {
    this.listWorkspace();
    this.workspaceListStyle = "block";
  }

  closeWorkspaceListDialog() {
    this.workspaceListStyle = "none";
  }

  openBoardsListDialog(workspaceId: any) {
    this.getBoardsList(workspaceId);
    this.boardsListStyle = "block";
  }

  closeBoardsListDialog() {
    this.boardsListStyle = "none";
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
        }else{
            this.router.navigate(['/create-workspace']);
        }
      });
    }else{
        this.router.navigate(['/login']);
    }
  }

  getBoardsList(workspaceId: any) {
    this.damService.getBoardsList(workspaceId).subscribe((data: any) => {
      this.boards = data;
    });
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    if (this.currentUser) {
      localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
        workspaceName: this.workspaceName, userRole: this.userRole }));
      this.router.navigate(['/dam/subscription']);
    }
  }
}
